import { Routes } from '@angular/router';
import { Overview } from './components/overview/overview';
import { CallCenterWrapperComponent } from './components/call-center-database/call-center-wrapper/call-center-wrapper.component';
import { LoginComponent } from './components/login/login';
import { ContractsListWrapperComponent } from './components/contracts/contracts-list-wrapper/contracts-list-wrapper.component';
import { IllustrationsWrapperComponent } from './components/illustrations/illustrations-wrapper/illustrations-wrapper.component';
import { AddNewIllustration } from './components/illustrations/add-new-illustration/add-new-illustration';
import { StatisticSummaryWrapperComponent } from './components/statistic-summary/statistic-summary-wrapper/statistic-summary-wrapper.component';
import { AdminWrapperComponent } from './components/admin/admin-wrapper/admin-wrapper.component';
import { Profile } from './shared/components/header/profile/profile';
import { DebugPage } from './pages/debug/debug';
import { CallCenterStatsWrapperComponent } from './components/call-center-stats/call-center-stats-wrapper/call-center-stats-wrapper.component';
import { DailyReportWrapperComponent } from './components/daily-report/daily-report-wrapper/daily-report-wrapper.component';
import { CustomersWrapperComponent } from './components/customers/customers-wrapper/customers-wrapper.component';
import { CustomersDetailsWrapperComponent } from './components/customers/customers-details/customers-details-wrapper.component';
import { CalendarWrapperComponent } from './components/calendar/calendar-wrapper/calendar-wrapper.component';
import { RoleGuard } from './guards/role.guard';
import { LoginRedirectGuard } from './guards/login-redirect.guard';

export const routes: Routes = [
  { 
    path: '', 
    component: LoginComponent, 
    canActivate: [LoginRedirectGuard] 
  },
  { path: 'login', component: LoginComponent, canActivate: [LoginRedirectGuard] },
  { path: 'overview', component: Overview, canActivate: [RoleGuard] },
  { path: 'calendar', component: CalendarWrapperComponent, canActivate: [RoleGuard] },
  { path: 'call-center-database', component: CallCenterWrapperComponent, canActivate: [RoleGuard] },
  { path: 'contracts', component: ContractsListWrapperComponent, canActivate: [RoleGuard] },
  { path: 'customers', component: CustomersWrapperComponent, canActivate: [RoleGuard] },
  { path: 'illustrations', component: IllustrationsWrapperComponent, canActivate: [RoleGuard] },
  { path: 'add-new-illustration', component: AddNewIllustration, canActivate: [RoleGuard] },
  { path: 'summary', component: StatisticSummaryWrapperComponent, canActivate: [RoleGuard] },
  { path: 'call-center-stats', component: CallCenterStatsWrapperComponent, canActivate: [RoleGuard] },
  { path: 'daily-report', component: DailyReportWrapperComponent, canActivate: [RoleGuard] },
  { path: 'admin', component: AdminWrapperComponent, canActivate: [RoleGuard] },
  { path: 'profile', component: Profile, canActivate: [RoleGuard] },
  { path: 'debug', component: DebugPage },
  { path: 'customer-details/:customerId', component: CustomersDetailsWrapperComponent, canActivate: [RoleGuard] },
  { path: 'company-details/:companyId', component: CustomersDetailsWrapperComponent, canActivate: [RoleGuard] }
];
